import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, extractApiError } from "../lib/api";
import StandaloneSystemHeader from "../components/branding/StandaloneSystemHeader";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent } from "../components/ui/card";
import ThemeToggle from "../components/theme/ThemeToggle";

const SUCCESS_MESSAGE =
  "Falls ein Konto zu dieser E-Mail-Adresse existiert, wurde eine E-Mail zum Zurücksetzen des Passworts versendet.";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const response = await api.post("/api/auth/password-reset/request", {
        email: email.trim(),
      });
      setSuccess(response?.data?.message || SUCCESS_MESSAGE);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 422) {
        setError("Bitte prüfe deine Eingaben.");
      } else {
        setError(extractApiError(err, "Es ist ein technischer Fehler aufgetreten. Bitte versuche es später erneut."));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-background text-foreground">
      <div className="pointer-events-none absolute inset-0 bg-grid opacity-50" aria-hidden />
      <div className="pointer-events-none absolute inset-0 bg-radial-brand" aria-hidden />

      <div className="absolute top-4 right-4 z-30">
        <ThemeToggle />
      </div>

      <div className="relative z-10 min-h-screen flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md">
          <StandaloneSystemHeader />

          <Card className="backdrop-blur-xl">
            <CardContent className="p-6 sm:p-8">
              <h1 className="font-display text-2xl font-semibold tracking-tight">Passwort vergessen</h1>
              <p className="text-sm text-muted-foreground mt-1">
                Gib die E-Mail-Adresse deines Kontos ein. Wir senden dir einen Link zum Zurücksetzen deines Passworts.
              </p>

              <form className="space-y-4 mt-6" onSubmit={handleSubmit}>
                <div className="space-y-1.5">
                  <Label htmlFor="forgot-password-email">E-Mail-Adresse</Label>
                  <Input
                    id="forgot-password-email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                  />
                </div>

                {success ? (
                  <div className="text-sm text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded-lg px-3 py-2.5">
                    {success}
                  </div>
                ) : null}

                {error ? (
                  <div className="text-sm text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2.5">
                    {error}
                  </div>
                ) : null}

                <Button type="submit" className="w-full" disabled={loading}>
                  {loading ? "Wird gesendet …" : "Link zum Zurücksetzen anfordern"}
                </Button>
              </form>

              <div className="mt-5 text-sm text-muted-foreground">
                Zurück zur{" "}
                <Link to="/login" className="text-primary underline-offset-4 hover:underline">
                  Anmeldung
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
